import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathMap = {
    '/admin-dashboard': 'Dashboard',
    '/job-postings-management': 'Jobs',
    '/candidate-pipeline': 'Pipeline',
    '/candidate-profile': 'Candidates',
    '/analytics-dashboard': 'Analytics',
    '/login': 'Login'
  };

  const generateBreadcrumbs = () => {
    const pathSegments = location?.pathname?.split('/')?.filter(segment => segment);
    const breadcrumbs = [{ label: 'Dashboard', path: '/admin-dashboard' }];

    if (location?.pathname !== '/admin-dashboard' && location?.pathname !== '/') {
      const currentPath = location?.pathname;
      const currentLabel = pathMap?.[currentPath] || 'Page';
      
      if (currentPath !== '/admin-dashboard') {
        breadcrumbs?.push({ label: currentLabel, path: currentPath });
      }
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (location?.pathname === '/login') {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6">
      {breadcrumbs?.map((crumb, index) => (
        <React.Fragment key={crumb?.path}>
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="text-muted-foreground/60" />
          )}
          {index === breadcrumbs?.length - 1 ? (
            <span className="text-foreground font-medium">{crumb?.label}</span>
          ) : (
            <button
              onClick={() => navigate(crumb?.path)}
              className="hover:text-foreground transition-colors duration-150 cursor-pointer"
            >
              {crumb?.label}
            </button>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;